'use client';

import { type RefObject, useEffect, useState } from 'react';

function usePauseOnInteraction(ref: RefObject<HTMLElement | null>): boolean {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element) return undefined;

    const listeners = [
      ['mouseenter', () => setIsHovered(true)],
      ['mouseleave', () => setIsHovered(false)],
      ['focusin', () => setIsFocused(true)],
      ['focusout', () => setIsFocused(false)],
    ] as const;

    listeners.forEach(([type, listener]) => element.addEventListener(type, listener));

    return () => listeners.forEach(([type, listener]) => element.removeEventListener(type, listener));
  }, [ref]);

  return isHovered || isFocused;
}

export { usePauseOnInteraction };
